/**
 * Impersonation is handled entirely server-side via the session guard
 * (lab404/laravel-impersonate): starting/leaving impersonation swaps the
 * authenticated user on the existing session, and same-origin API calls
 * authenticate statefully through the session cookie. The browser therefore no
 * longer needs to juggle bearer tokens in localStorage, which removed the
 * token-theft surface this manager previously created (SUPPORT-663 / F-024).
 *
 * This shim is retained so existing imports keep working; initialize() is now a
 * no-op.
 */
export class ImpersonationManager {
    async initialize() {
        // Intentionally empty — impersonation state lives in the session.
    }

    isImpersonating() {
        return false;
    }
}

// Create singleton instance
export const impersonationManager = new ImpersonationManager();
